var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BoletinView',{attrs:{"fetch-path":"settlementplayer","toolbar-title":"Reporte mensual de salarios","type-label-hide":true,"descripion-label":"Observación","period":""}})}
var staticRenderFns = []

export { render, staticRenderFns }